import React from 'react';
import { ValidMe } from 'businessLogic/validation.js';
import Txt from '../../../inputs/textInput.js';
import { Dropdown } from 'semantic-ui-react';

const CenterPanel = (props) => {
  let editVersionMarkup = (
    <div className="ui form">
      <ValidMe
        validmefor="length@3-120"
        trim={true}
        validmemessage={APP.LANGUAGE.Errors.OrgUnitInvalidLength}
        group="createOrgUnitForm"
        fieldClasses="mrtl"
      >
        <Txt
          tabIndex="1"
          focusme="true"
          name="orgName"
          noTitle
          autoComplete="not-enable"
          onBlur={props.orgNameFocusOut}
          onChange={props.changeOUName}
          placeholder={APP.LANGUAGE.OrgUnitGeneralInfo.OrgUnitName}
        />
      </ValidMe>
      <ValidMe
        validmefor="length@3-16"
        group="createOrgUnitForm"
        validmemessage={APP.LANGUAGE.Errors.OrgAbbreviationLength}
        fieldClasses="mrtl"
      >
        <Txt
          tabIndex="2"
          maxLength={16}
          name="orgAbbrev"
          noTitle
          onChange={props.setOUAbbr}
          placeholder={APP.LANGUAGE.OrgUnitGeneralInfo.OrgUnitAbbrevPlaceholder}
        />
      </ValidMe>
      {props?.shortUrls?.length > 0 && props.selectedShortUrlValue && (
        <div className="mrtl">
          <div className="bold title-sms">{APP.LANGUAGE.CreateOrgUnit.shortUrl}</div>
          <Dropdown
            className="shorturl-dropdown"
            options={props.shortUrls}
            defaultValue={props.shortUrls.findIndex((item) => item.text === props.selectedShortUrlValue)}
            onChange={props.changeShortUrl}
            fluid
            selection
          />
          <div className="mrbm placeholder-label">
            <span>{APP.LANGUAGE.CreateOrgUnit.shortUrlInputSuggestionLabel}</span>
          </div>
        </div>
      )}
    </div>
  );

  return <div className="mrbl pdtsss">{editVersionMarkup}</div>;
};

export default CenterPanel;
